import React from 'react';

function SchoolField({ value, onChange, error }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0px",
        maxWidth: "100%",
      }}
    >
	<label
        htmlFor="School1"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          flexWrap: "wrap",
        }}
      >
	
      
        <select
  name="selection4"
  value={value.selection4}
  onChange={onChange}
  style={{
    flex: "1",
    minWidth: "50px",
    padding: "10px",
    borderRadius: "8px",
    border: "1px solid #80dfff", // Light blue border
    fontSize: "1rem",
    background: "linear-gradient(135deg, #e0f7ff, #80dfff)", // Blue gradient
    color: "#007fff", // Blue font color

    // ❌ Removed appearance override to restore native dropdown arrow
    // appearance: "none",
    // WebkitAppearance: "none",
    // MozAppearance: "none",

    boxShadow: "0px 4px 8px rgba(128, 223, 255, 0.4)", // Light blue shadow
    transition: "background-color 0.3s ease",
    cursor: "pointer",
  }}
>
  <option value="School">School</option>
  <option value="College">College</option>
  <option value="Campus">Campus</option>
  <option value="Univ.">University</option>
  <option value="Institute">Institute</option>
  <option value="Academy">Academy</option>
</select>


        <input
          type="text"
          name="School1"
          value={value.School1}
          onChange={onChange}
          placeholder="Enter Institution name"
          style={{
            flex: "2",
            minWidth: "100px",
            padding: "10px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontSize: "1rem",
            boxSizing: "border-box",
          }}
        />
      </label>

      {error && <div style={{ color: "red", fontSize: "12px" }}>{error}</div>}
    </div>
  );
}

export default SchoolField;
